document.querySelectorAll('[data-guarantee-toggle-link]').forEach(function (link) {
    link.addEventListener('click', function (e) {
        e.preventDefault();
        link.closest('[data-guarantee-block]').classList.toggle('guarantee-rules__item-closed');
    })
});